import React  from 'react';
import PercentageComponentProto from './percentage-proto.jsx';


export default function renderPercentageInFormNew(id, props) {
    return <PercentageComponentProto renderMode="form-new" id={id} {...props} />;
}